import {Box, FormControlLabel, Switch} from '@mui/material';
import React from 'react';
import {styles} from './ControlOptions.styles';
import {EShowHeaderFooter, IFooterControls} from '@opengov/stories-shared/constants';
import {ISetupPdfMessages} from '../../../../../../types/setupPDFTypes';
import {ControlOptions} from './ControlOptions';
import {ExportType} from "../../../../SetupPDFComponents/SetupPDFHeader/SetupPDFHeader";

export const FooterOptions = ({
  messages,
  footerControls,
  onFooterControlsChange,
  exportType
}: {
  messages: ISetupPdfMessages;
  footerControls: IFooterControls;
  onFooterControlsChange: (value: IFooterControls) => void;
  exportType: ExportType;
}) => {
  return (
    <Box sx={styles.container}>
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" inputProps={styles.controls} />}
        label={exportType == ExportType.SECTION ? messages.showSectionName : messages.showPublicationName}
        labelPlacement="start"
        checked={footerControls?.showFolderName}
        onChange={() => {
          onFooterControlsChange({
            ...footerControls,
            showFolderName: !footerControls?.showFolderName
          } as IFooterControls);
        }}
      />
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" inputProps={styles.controls} />}
        label={messages.showExportTimestamp}
        labelPlacement="start"
        checked={footerControls?.showTimestamp}
        onChange={() => {
          onFooterControlsChange({
            ...footerControls,
            showTimestamp: !footerControls?.showTimestamp
          } as IFooterControls);
        }}
      />
      <Box>
        <FormControlLabel
          sx={styles.switchControlLabel}
          control={<Switch size="small" inputProps={styles.controls} />}
          label={messages.showPageNumbers}
          labelPlacement="start"
          checked={footerControls?.showPageNumber}
          onChange={() => {
            onFooterControlsChange({
              ...footerControls,
              showPageNumber: !footerControls?.showPageNumber
            } as IFooterControls);
          }}
        />
        {/* <RadioGroup
          aria-labelledby={`page-numbers-options-radio-buttons-group-label`}
          name={`page-numbers-options-radio-buttons-group`}
          value={footerControls?.pageNumberOption || EShowPageNumbers.FromFirstPage}
          onChange={(event) => {
            onFooterControlsChange({
              ...footerControls,
              pageNumberOption: event.target.value as EShowPageNumbers
            } as IFooterControls);
          }}
        >
          <FormControlLabel
            value={EShowPageNumbers.FromFirstPage}
            control={<Radio inputProps={styles.controls} />}
            label={messages.fromFirstPage}
            disabled={!footerControls?.showPageNumber}
          />
          <FormControlLabel
            value={EShowPageNumbers.OnlyAfterToc}
            control={<Radio inputProps={styles.controls} />}
            label={messages.onlyAfterToc}
            disabled={!footerControls?.showPageNumber}
          />
        </RadioGroup> */}
      </Box>
      <ControlOptions
        type="footer"
        messages={messages}
        selectedOption={footerControls?.showFooterOn || EShowHeaderFooter.All}
        handleOptionChange={(option) => {
          onFooterControlsChange({ ...footerControls, showFooterOn: option } as IFooterControls);
        }}
      />
    </Box>
  );
};
